import { ApiRequest } from "src/models/api.request";
import api from "../core/api";
import { helper } from "src/utils/helper";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import HbsIslemtanimDTO from "src/models/GenelTanimlar/hbsislemtanimDTO";
import VwTestDetaybilgiDTO from "src/models/GenelTanimlar/VwTestDetaybilgiDTO";


const controllerName = "VwTestDetaybilgiDTO/";

export const IslemApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTestDetayBilgi: builder.query<Array<VwTestDetaybilgiDTO>, {
            id?: number,
            aktifGoster: boolean
        }>({
            query: (request) => {
                let req: ApiRequest<VwTestDetaybilgiDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: []
                    },
                    sorts: [{ fieldName: 'id', ascending: false }]
                }
                
                if (request.aktifGoster)
                    req.filters.predicates.push({
                        fieldName: 'aktif',
                        operator: '=',
                        value1: 'E'
                    });

                if (request?.id > 0)
                    req.filters.predicates.push({
                        fieldName: "testId",
                        operator: "=",
                        value1: request.id
                    });

                return {
                    url: controllerName + "find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ["TestDetayBilgi"],
            keepUnusedDataFor: 0
        }),

        TestDetayBilgiAdd: builder.mutation<VwTestDetaybilgiDTO, VwTestDetaybilgiDTO>({
            query: (request) => ({
                url: controllerName,
                method: "POST",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["TestDetayBilgi"]
        }),
        TestDetayBilgiUpdate: builder.mutation<VwTestDetaybilgiDTO, VwTestDetaybilgiDTO>({
            query: (request) => ({
                url: controllerName,
                method: "PUT",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["TestDetayBilgi"]
        }),
        TestDetayBilgiDelete: builder.mutation<boolean, number>({
            query: (id) => ({
                url: controllerName + `${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["TestDetayBilgi"]
        }),
    })
});

export const {
    useGetTestDetayBilgiQuery,
    useLazyGetTestDetayBilgiQuery,
    useTestDetayBilgiAddMutation,
    useTestDetayBilgiUpdateMutation,
    useTestDetayBilgiDeleteMutation
} = IslemApi